export const stringMapDefault = {
    controlLabelTable: "Table",
    controlLabelTypeStyle: "Text Block Style",
    controlLabelColor: "Font Color",
    controlLabelFontFamily: "Font Family",
    controlLabelFontSize: "Font Size",
    controlLabelBold: "Bold ({metaKey} + B)",
    controlLabelItalic: "Italic ({metaKey} + I)",
    controlLabelUnderline: "Underline ({metaKey} + U)",
    controlLabelAlignLeft: "Align left ({metaKey} + Shift + L)",
    controlLabelAlignCenter: "Align center ({metaKey} + Shift + E)",
    controlLabelAlignRight: "Align right ({metaKey} + Shift + R)",
    controlLabelOrderedList: "Ordered list ({metaKey} + Shift + 7)",
    controlLabelUnorderedList: "Unordered list ({metaKey} + Shift + 8)",
    controlLabelOutdent: "Outdent List  {metaKey} + [)", // Should update these to use HTML and properly announce
    controlLabelIndent: "Indent List ({metaKey} + ])",
    controlLabelImage: "Insert Image",
    controlLabelLink: "Insert Link",
    controlLabelClearFormatting: "Clear Formatting",
    controlLabelRedo: "Redo",
    controlLabelUndo: "Undo"
};
